import { BooleanInput, Filter as RaFilter, SearchInput } from "react-admin";

import React from "react";

const LayoutFilter = ({ type, options, label, ...props }) => {
  switch (type) {
    case "string":
      return <SearchInput {...props} />;
    case "boolean":
      return <BooleanInput {...props} label={label} />;
    default:
      return null;
  }
};
const Filters = ({ layoutFilters, ...props }) => (
  <RaFilter {...props}>
    {layoutFilters.map((filter) => (
      <LayoutFilter
        key={filter.name}
        source={filter.name}
        label={filter.alias}
        alwaysOn
        {...filter}
      />
    ))}
  </RaFilter>
);
export default Filters;
